import { a } from "../../dummyData";

const ProjectSection = ({ projects = [] }) => {
    if (projects.length <= 0) return null
    return (
        <div className="project">
            <h3>Projects</h3>
            <div className="project__container">
                {projects.map(({ title, points }, index) => {
                    return (
                        <div key={index} className="project__container__item">
                            <h3>{title}</h3>
                            <div className="project__container__item__listContainer">
                                <ol>
                                    {
                                        points.map((point, _index) => (
                                            <li key={_index}>
                                                <img src="/assets/certificate/arrowIcon.png" alt="point" />
                                                <h5>{point}</h5>
                                            </li>
                                        ))
                                    }
                                </ol>
                            </div>
                        </div>
                    )
                })}

            </div>
        </div>
    );
}

export default ProjectSection;